// export const PROD_URL = "https://dev.jiitu.co.id";
// export const PROD_URL = "https://bela-jakarta.piawaindonesia.id";
export const PROD_URL = "https://dev-bela.piawaindonesia.id";
export const DEV_URL = "http://jitudevus.pex";